import { gql } from '@apollo/client';

const SET_USER_EMAIL_PREFERENCES = gql`
  mutation SetUserEmailPreferences($optInForFutureAlerts: Boolean!) {
    setUserEmailPreferences(optInForFutureAlerts: $optInForFutureAlerts)
  }
`;

export default SET_USER_EMAIL_PREFERENCES;
